<template>
  <form @submit.prevent="handleSubmit">
    <slot />
  </form>
</template>

<script setup>
const handleSubmit = (event) => {
  emit('submit', event);
};

const emit = defineEmits(['submit']);
</script>
